import { useEffect } from 'react';
import { BrandHero, CtaBand, SectionHeader } from '@/components/brand/BrandKit';
import { LeaderCard } from '@/components/LeadershipSection';
import { founders, leaders } from '@/data/leadership';

const HERO_IMG = "https://customer-assets.emergentagent.com/job_egmg-premium/artifacts/cmkxgqfh_image.png";

export default function LeadershipPage() {
  useEffect(() => { document.title = "Leadership | Eurogulf Mobility Group"; }, []);

  return (
    <div data-testid="leadership-page">
      <BrandHero testid="leadership-hero" chip="The People Behind the Movement" title="Leadership built on 50 years of moving the UAE."
        lead="The founders and senior team guiding Eurogulf Mobility Group's strategy, operations and service across the UAE."
        image={HERO_IMG} imageAlt="Eurogulf Mobility Group leadership" position="center 30%" />

      <section data-testid="leadership-founders" className="bg-white py-14 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeader compact chip="Our Founders" title="The vision that started it all in 1976." desc="The visionary founders who established Eurogulf Mobility Group in 1976 and built it into one of the UAE's most trusted mobility conglomerates." align="center" />
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-3xl mx-auto">
            {founders.map((o, i) => <LeaderCard key={o.id} person={o} lang="en" isFounder index={i} />)}
          </div>
        </div>
      </section>

      <section data-testid="leadership-team" className="bg-[#FAFAFA] border-t border-black/5 py-14 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeader compact chip="Senior Leadership Team" title="Experience that drives the group forward." desc="A diverse team of industry professionals driving Eurogulf Mobility Group's strategic vision, operational excellence, and continued growth across the UAE." align="center" />
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {leaders.map((l, i) => <LeaderCard key={l.id} person={l} lang="en" isFounder={false} index={i + 2} />)}
          </div>
        </div>
      </section>

      <CtaBand title="Join our team." desc="With 1,200+ professionals, Eurogulf Mobility Group offers career paths that make a difference. Be part of the movement."
        ctas={[{ label: 'Explore Careers', href: '/careers', testid: 'leadership-careers-cta' }]} />
    </div>
  );
}
